import type {
  AssessmentData,
  JobOpeningData,
  UserData,
} from '../../../../utils/types/DashboardTypes';
import type { IAssessmentRow, IJobOpeningRow, IUserRow } from '../interfaces';

/**
 * Pure data mapping function for Job Openings.
 * Transforms raw API payload into typed table rows.
 */
export const mapJobOpeningsToRows = (openings: JobOpeningData[] = []): IJobOpeningRow[] => {
  return openings.map((job) => ({
    id: job.id,
    'Job Title': job.jobTitle,
    'Job Reference': job.job_reference,
    Applicants: job.applicants,
    Suitable: job.suitable,
    Outstanding: job.outstanding,
    Shortlisted: job.shortlisted,
    Unsuccessful: job.unsuccessful,
    'Start Date': job.startDate,
    'End Date': job.endDate,
  }));
};

/**
 * Pure data mapping function for Assessments.
 * Transforms raw API payload into typed table rows.
 */
export const mapAssessmentsToRows = (assessments: AssessmentData[] = []): IAssessmentRow[] => {
  return assessments.map((item) => ({
    id: item.id,
    'Assessment Title': item['Assessment Title'],
    Assigned: item.Assigned,
    Completed: item.Completed,
    Expired: item.Expired,
    Shortlisted: item.Shortlisted,
    Unsuccessful: item.Unsuccessful,
    'Start Date': item['Start Date'],
    'End Date': item['End Date'],
  }));
};

/**
 * Pure data mapping function for Users.
 * Transforms raw API payload into typed table rows.
 */
export const mapUsersToRows = (users: UserData[] = []): IUserRow[] => {
  return users.map((user, index) => ({
    id: `${user.Name}-${user.Email}-${index}`,
    Name: user.Name,
    Email: user.Email,
    'Profile Picture': user['Profile Picture'],
    'User Type': user['User Type'],
    'Roles Assigned': user['Roles Assigned'],
    Assessments: user.Assessments,
    'Job Applicants': user['Job Applicants'],
    'Last Login': user['Last Login'],
  }));
};
